import InfoBlock from "@/components/UI/InfoBlock";
import MyLoader from '@/components/UI/MyLoader';
import NetworkStatus from "@/components/UI/NetworkStatus";
import PopupMessage from "@/components/UI/PopupMessage";
import SwitcherSizes from "@/components/UI/SwitcherSizes";

export default [
    InfoBlock,
    MyLoader,
    NetworkStatus,
    PopupMessage,
    SwitcherSizes,
];